<template>

<app-table-cell class="preferences" :border="border" :class="{'no-padding': noPadding, 'inline': inline}" :align="align">

	<div v-for="(time, index) in times" :key="index" class="preferences-time">{{ $con.schedule.days[time.day].slice(0, 3) }} {{ $con.schedule.times[time.time] }} ({{ $con.schedule.durations[time.duration] }})</div>

</app-table-cell>

</template>

<script>

export default {

	props: ['border', 'noPadding', 'inline', 'align', 'times']

}

</script>

<style scoped>

.preferences {
    display: flex;
}

.preferences-time {
	font-size: 14px;
    text-align: center;
	padding: 5px 6px;
	line-height: 18px;
	font-weight: 400;
	border-radius: 4px;
	background-color: #fff;
    border: 1px solid #eee;
    margin-right: 4px;
}

</style>
